import { Component, Input, OnInit } from '@angular/core';
import { FileType, IFileDocument } from '../../../types/file-document';

@Component({
  selector: 'announcement-view',
  templateUrl: './announcement-view.component.html',
  styleUrls: ['./announcement-view.component.scss']
})
export class AnnouncementViewComponent implements OnInit {

  static supportedFileTypes = [
      'pdf'
  ];

  document: IFileDocument;

  fileType = FileType;

  /**
   * Default height is standard page size
   * if set null, full height without scroll will be shown
   */
  @Input() maxHeight = null;

  @Input() set fileDocument(document: IFileDocument) {
    this.isLoading = true;
    this.document = document;

    if(document.mime !== FileType.pdf) {
      this.onLoadComplete();
    }
  }

  isLoading: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  onLoadComplete() {
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcement-view/announcement-view.component.ts